import 'uni-pages';
import Vue from 'vue'
import Page from './demo/packageEditor/preview-post.vue'
createPage(Page)